export class AddItemFromTemplateError extends Error {
  constructor(
    message: string = 'Failed to add item to inspection template',
    options?: ErrorOptions
  ) {
    super(message, options);
    this.name = 'AddItemFromTemplateError';
  }
}
